import Immutable from 'seamless-immutable';
import _ from 'lodash';

import {
  SAVE_COMMUNICATIONS,
  APPEND_COMMUNICATIONS,
  SET_COMMUNICATIONS_PAGINATION_DATA,
  SELECT_COMMUNICATION,
  SAVE_COMMUNICATION,
  SET_COMMUNICATIONS_FILTER,
  UPDATE_COMMUNICATION,
  RESET_COMMUNICATIONS_FILTERS,
  RESET_COMMUNICATIONS_DATA,
  RESET_COMMUNICATION_PAGINATION_DATA,
  SET_COMMUNICATIONS_OPERATIONAL_MODE,
  SAVE_COMMUNICATION_USERS,
  APPEND_COMMUNICATION_USERS,
  SAVE_COMMUNICATION_USERS_PAGINATION_DATA,
  SAVE_COMMUNICATION_USERS_TOTAL,
  RESET_COMMUNICATION_USERS_FILTERS,
  SET_COMMUNICATION_USERS_FILTER,
} from '../actions/actionTypes/communications';

const initialState = Immutable({
  data: {
    content: [],
    pagination: {},
    filters: {},
  },
  isOperationalMode: false,
  selectedCommunication: {},
  selectedCommunicationUsersTotal: null,
  selectedCommunicationUsers: {
    content: [],
    pagination: {},
    filters: {},
  },
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_COMMUNICATIONS:
      return state.setIn(['data', 'content'], action.communications);
    case APPEND_COMMUNICATIONS:
      return state.setIn(['data', 'content'], [...state.data.content, ...action.communications]);
    case SAVE_COMMUNICATION:
      return state.setIn(['data', 'content'], [...state.data.content, action.communication]);
    case SET_COMMUNICATIONS_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], action.pagination);
    case SELECT_COMMUNICATION:
      return state.set('selectedCommunication', action.communication);
    case SET_COMMUNICATIONS_OPERATIONAL_MODE:
      return state.set('isOperationalMode', action.value);
    case SET_COMMUNICATIONS_FILTER:
      return state.setIn(['data', 'filters', action.field], action.value);
    case UPDATE_COMMUNICATION: {
      const index = _.findIndex(state.data.content, data => data.id === action.communication.id);
      if (index !== -1) {
        return state.setIn(['data', 'content', index], action.communication);
      }
      return state;
    }
    case RESET_COMMUNICATIONS_FILTERS:
      return state.setIn(['data', 'filters'], {});
    case RESET_COMMUNICATIONS_DATA:
      return state.set('data', initialState.data);
    case RESET_COMMUNICATION_PAGINATION_DATA:
      return state.setIn(['data', 'pagination'], {});
    case SAVE_COMMUNICATION_USERS:
      return state.setIn(['selectedCommunicationUsers', 'content'], action.users);
    case APPEND_COMMUNICATION_USERS:
      return state.setIn(['selectedCommunicationUsers', 'content'], [...state.selectedCommunicationUsers.content, ...action.users]);
    case SAVE_COMMUNICATION_USERS_PAGINATION_DATA:
      return state.setIn(['selectedCommunicationUsers', 'pagination'], action.pagination);
    case SAVE_COMMUNICATION_USERS_TOTAL:
      return state.set('selectedCommunicationUsersTotal', action.total);
    case RESET_COMMUNICATION_USERS_FILTERS:
      return state.setIn(['selectedCommunicationUsers', 'filters'], {});
    case SET_COMMUNICATION_USERS_FILTER:
      return state.setIn(['selectedCommunicationUsers', 'filters', action.field], action.value);
    default:
      return state;
  }
}
